/* ==========================================================================
   ASPY · ANIMACIONES PARA TODA LA WEB
   Scroll suave, transición entre páginas, títulos palabra a palabra, bloques
   y fotos que aparecen al llegar, parallax suave y la ficha de producto.
   La portada animada (as-cine) usa el mismo scroll suave: window.asLenis.
   ========================================================================== */
(function () {
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raton = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var html = document.documentElement;
  if (quieto) return;
  html.classList.add('as-a');

  /* ---------- Scroll suave (ordenador) ---------- */
  function arrancaLenis() {
    if (window.asLenis || !raton || !window.Lenis) return;
    window.asLenis = new window.Lenis({ lerp: 0.08, wheelMultiplier: 0.85 });
    (function bucle(t) { window.asLenis.raf(t); requestAnimationFrame(bucle); })(performance.now());
  }

  /* ---------- Barra de progreso y cortina ---------- */
  var barra = document.createElement('div'); barra.className = 'as-a-progreso'; barra.setAttribute('aria-hidden', 'true');
  var cortina = document.createElement('div'); cortina.className = 'as-a-cortina'; cortina.setAttribute('aria-hidden', 'true');

  /* Salida suave al ir a otra página de la tienda */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download') || a.closest('cart-drawer, .drawer, details, [data-no-transicion]')) return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin || url.pathname.indexOf('/checkout') === 0 || url.pathname.indexOf('/cart/') === 0) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    e.preventDefault();
    html.classList.add('as-a-sale');
    setTimeout(function () { location.href = a.href; }, 420);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) html.classList.remove('as-a-sale'); });

  /* ---------- Marcar elementos ---------- */
  var FUERA = '.cx-hero, .cx-pista, header, footer, .shopify-section-group-header-group, .shopify-section-group-footer-group, [data-cine], .as-prod__fija, cart-drawer, .drawer, dialog, .as-cookies, [data-as-cookies], #shopify-pc__banner';
  var visto = new IntersectionObserver(function (entradas) {
    var n = 0;
    entradas.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      if (!el.style.getPropertyValue('--as-a-d')) el.style.setProperty('--as-a-d', (n++ * 70) + 'ms');
      el.classList.add('is-in');
      visto.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

  function partePalabras(el) {
    var i = 0;
    (function recorre(nodo) {
      Array.prototype.slice.call(nodo.childNodes).forEach(function (h) {
        if (h.nodeType === 3) {
          var trozos = h.textContent.split(/(\s+)/);
          var frag = document.createDocumentFragment();
          trozos.forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(' ')); return; }
            var caja = document.createElement('span'); caja.className = 'as-a-pal';
            var dentro = document.createElement('span'); dentro.style.setProperty('--i', i++); dentro.textContent = t;
            caja.appendChild(dentro); frag.appendChild(caja);
          });
          h.parentNode.replaceChild(frag, h);
        } else if (h.nodeType === 1 && h.tagName !== 'EM' && h.tagName !== 'BR' && h.tagName !== 'SVG') {
          recorre(h);
        } else if (h.nodeType === 1 && h.tagName === 'EM') {
          // el texto en cobre va entero, para no romper el degradado
          var caja2 = document.createElement('span'); caja2.className = 'as-a-pal';
          var dentro2 = document.createElement('span'); dentro2.style.setProperty('--i', i++);
          h.parentNode.insertBefore(caja2, h); dentro2.appendChild(h); caja2.appendChild(dentro2);
        }
      });
    })(el);
  }

  function marca(raiz) {
    var main = raiz || document.getElementById('MainContent');
    if (!main) return;
    var libre = function (el) { return !el.closest(FUERA) && !el.closest('.as-aparece') && !el.classList.contains('as-aparece') && !el.dataset.asA; };
    var suelto = function (el) { return !el.closest(FUERA) && !el.dataset.asA; };

    main.querySelectorAll('h1, h2, .as-h1, .as-h2').forEach(function (el) {
      if (!suelto(el) || el.closest('.as-a-titulo') || !el.textContent.trim()) return;
      el.dataset.asA = '1';
      el.setAttribute('aria-label', el.textContent.trim().replace(/\s+/g, ' '));
      partePalabras(el);
      el.querySelectorAll('.as-a-pal').forEach(function (p) { p.setAttribute('aria-hidden', 'true'); });
      el.classList.add('as-a-titulo'); visto.observe(el);
    });

    main.querySelectorAll('img').forEach(function (img) {
      var caja = img.parentElement;
      if (!suelto(img) || !caja || caja.dataset.asA || img.closest('.as-prod__mini, .as-prod__principal, .cart-item, .as-pagina__sello, a.as-btn, .cx-hero, .cx-pista, .cx-foto, .ct-tarjeta__media')) return;
      var w = img.getAttribute('width') || img.naturalWidth || 0;
      if (w && w < 300) return;
      if (caja.tagName === 'PICTURE') caja = caja.parentElement;
      caja.dataset.asA = '1';
      caja.classList.add('as-a-foto');
      if (getComputedStyle(caja).overflow === 'hidden') caja.classList.add('as-a-par');
      visto.observe(caja);
    });

    main.querySelectorAll('p, li, .as-btn, .as-pack, .as-prod__precio, .as-prod__compra, .as-prod__ventajas, .as-prod__acordeon, .as-prod__video, .cart-item, .totals, .tax-note, .cart__ctas, .field, .contact__button, .card-wrapper, .rte > *').forEach(function (el) {
      if (!libre(el) || el.closest('.as-a-titulo, .as-a-sube, .as-pack__op, .as-a-foto, nav')) return;
      el.dataset.asA = '1';
      el.classList.add('as-a-sube'); visto.observe(el);
    });
  }

  /* ---------- Parallax de las fotos con marco ---------- */
  var alto = window.innerHeight;
  window.addEventListener('resize', function () { alto = window.innerHeight; });
  function parallax() {
    document.querySelectorAll('.as-a-par.is-in').forEach(function (c) {
      var r = c.getBoundingClientRect();
      if (r.bottom < 0 || r.top > alto) return;
      var centro = (r.top + r.height / 2 - alto / 2) / alto;
      c.style.setProperty('--as-a-py', (centro * -6).toFixed(2));
    });
    var max = document.documentElement.scrollHeight - alto;
    barra.style.setProperty('--as-a-p', max > 0 ? (window.scrollY / max).toFixed(4) : 0);
    requestAnimationFrame(parallax);
  }

  /* Red de seguridad: lo que ya quedó por encima de la pantalla se muestra igualmente */
  setInterval(function () {
    document.querySelectorAll('.as-a-sube:not(.is-in), .as-a-titulo:not(.is-in), .as-a-foto:not(.is-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < alto * 0.9) { el.classList.add('is-in'); visto.unobserve(el); }
    });
  }, 600);

  /* ---------- Botones que siguen al ratón ---------- */
  function iman() {
    if (!raton) return;
    document.querySelectorAll('.as-btn').forEach(function (b) {
      if (b.closest('.as-prod__fija')) return;
      b.classList.add('as-a-iman');
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18, y = (e.clientY - r.top - r.height / 2) * 0.3;
        b.style.transform = 'translate(' + x.toFixed(1) + 'px,' + (y - 2).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Ficha de producto ---------- */
  function producto() {
    var marco = document.querySelector('.as-prod__principal');
    if (!marco) return;
    var img = marco.querySelector('img');
    if (!img) return;
    new MutationObserver(function () {
      img.classList.remove('as-a-cambia'); void img.offsetWidth; img.classList.add('as-a-cambia');
    }).observe(img, { attributes: true, attributeFilter: ['src'] });
    if (raton) {
      marco.classList.add('as-a-lupa');
      marco.addEventListener('mousemove', function (e) {
        var r = marco.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
      });
    }
  }

  function inicia() {
    document.body.appendChild(barra);
    document.body.appendChild(cortina);
    arrancaLenis();
    marca();
    iman();
    producto();
    requestAnimationFrame(parallax);
    // el carrito se vuelve a pintar al cambiar cantidades
    document.addEventListener('cart:updated', function () { marca(); });
    var carrito = document.querySelector('#main-cart-items, cart-items');
    if (carrito) new MutationObserver(function () { marca(carrito); }).observe(carrito, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia); else inicia();
  window.addEventListener('load', arrancaLenis);
})();
